import { Map } from 'immutable'
import { actions } from './actions'

const initialState = Map({
    refreshingToken: false,
    screenError: false,
    screenErrorDescription: '',
})

export default (state = initialState, action) => {
    const { type, payload } = action

    switch (type) {
        case actions.REFRESH_TOKEN: {
            return state.set('refreshingToken', true)
        }

        case actions.REFRESH_TOKEN_COMPLETE: {
            return state.set('refreshingToken', false)
        }
        case actions.SET_SCREEN_ERROR: {
            return state.merge({
                screenError: true,
                screenErrorDescription: payload,
            })
        }
        default:
            return state
    }
}
